module.exports = __webpack_public_path__ + "static/media/rectangle-comments.a81c3ef6.svg";